import './WaterMark.less'
import WaterMark from './WaterMark'

export type { WaterMarkProps } from './iWaterMark'

export default WaterMark
